import { State } from "./State";
export class RoomReward {
    constructor(text) {
        this.text = new State(text);
    }
    toJSON() {
        const { text } = this;
        return { text };
    }
}
